module.exports = __webpack_public_path__ + "static/media/Horizontal_Sabaeus_RGB.5d9f0363.svg";